export default class productBillingApi {
    constructor(axios, pid) {
        this.axios = axios
        this.pid = pid
    }

    getBilling() {
        
        return this.axios.get('index.php?m=proxycheap&json=1&c=ProductBillingCycles&pid='+this.pid)
    }
}
